/** How meetings' times, lengths and platforms read on every page. Times are
 * stored in UTC and shown in the viewer's own time zone. */

/** Google Meet, Zoom or Microsoft Teams, from the meeting's link. */
export function platform(url: string | null): string | null {
  if (!url) return null;
  if (url.includes("meet.google.com")) return "Google Meet";
  if (url.includes("zoom.")) return "Zoom";
  if (url.includes("teams.")) return "Microsoft Teams";
  return null;
}

/** 1h 46m, 45m, or 12m 30s for a short one with seconds to show. */
export function duration(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.round(seconds % 60);
  if (hours) return `${hours}h ${minutes}m`;
  return secs && minutes < 10 ? `${minutes}m ${secs}s` : `${minutes}m`;
}

/** 14:00 today, "Tomorrow 10:30", or "Wed 1 Oct, 10:30" further out. */
export function upcomingTime(value: string): string {
  const moment = new Date(value);
  const time = moment.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" });
  const days = dayDifference(moment);
  if (days === 0) return time;
  if (days === 1) return `Tomorrow ${time}`;
  return `${moment.toLocaleDateString(undefined, { weekday: "short", day: "numeric", month: "short" })}, ${time}`;
}

/** 29 Sep, with the year only when it isn't this year. */
export function shortDate(value: string | null): string {
  if (!value) return "—";
  const moment = new Date(value);
  const sameYear = moment.getFullYear() === new Date().getFullYear();
  return moment.toLocaleDateString(undefined, { day: "numeric", month: "short", ...(sameYear ? {} : { year: "numeric" }) });
}

/** Whole calendar days from today to `moment`, in the viewer's time zone. */
function dayDifference(moment: Date): number {
  const start = (date: Date) => new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
  return Math.round((start(moment) - start(new Date())) / 86_400_000);
}
